import React, { useState, useEffect } from "react";
import Storage from "../../services/storage.service";
import DropOffScreen from "./drop-off-screen";

const DropOff = ({ children, error }) => {
  const [dropOffJourney, setDropOffJourney] = useState(
    localStorage.getItem("TabSwitched")
  );
  const [dropOffJourneyVisibility, setDropOffJourneyVisibility] =
    useState(false);
  const [dropOffTime, setDropOffTime] = useState("");

  const handleUnload = (e) => {
    sessionStorage.setItem("reloaded", true);
    localStorage.setItem("ReloadedOrLeft", true);
  };
  console.log(
    "dropOffJourneyVisibility===>",
    dropOffJourneyVisibility,
    dropOffTime
  );

  const handleSwitchTab = () => {
    let flag = Storage.get("flags");
    if (
      document.visibilityState === "hidden" &&
      !localStorage.getItem("ReloadedOrLeft") &&
      flag?.PaymentPending
    ) {
      localStorage.setItem("TabSwitched", true);
      setDropOffTime(new Date());
      setDropOffJourney(true);
    }
    if (
      document.visibilityState === "visible" &&
      !localStorage.getItem("ReloadedOrLeft") &&
      flag?.PaymentPending
    ) {
      sessionStorage.setItem("TabSwitchedBack", true);
      setDropOffTime(new Date());
      setDropOffJourneyVisibility(true);
    }
    if (window.location.href.indexOf("random") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("category") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("search-number") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("number") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("mnp") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("activation-inprogress") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("activation-failed") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("activated") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("store-pickup") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("delivery") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("absher-validation") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("pay") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
    if (window.location.href.indexOf("confirmation") > 1) {
      setDropOffJourney(false);
      setDropOffJourneyVisibility(false);
      setDropOffTime("");
      localStorage.removeItem("TabSwitched");
      sessionStorage.removeItem("TabSwitchedBack");
      return;
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleUnload);
    if (!localStorage.getItem("WelcomeBack")) {
      window.addEventListener("visibilitychange", handleSwitchTab);
    }
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
      window.removeEventListener("visibilitychange", handleSwitchTab);
    };
  }, [window.location.href]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    Storage.get_obsrv("flags").subscribe((data) => {
      if (data) {
        let flag = data;
        if (
          sessionStorage.getItem("reloaded") === "true" &&
          localStorage.getItem("ReloadedOrLeft") === "true"
        ) {
          sessionStorage.removeItem("reloaded");
          localStorage.removeItem("ReloadedOrLeft");
        } else if (localStorage.getItem("ReloadedOrLeft") === "true") {
          if (
            (window.location.href.substr(-3) !== "/#/" ||
            window.location.href.indexOf("random") === -1 ||
            window.location.href.indexOf("category") === -1 ||
            window.location.href.indexOf("search-number") === -1 ||
            window.location.href.indexOf("number") === -1 ||
            window.location.href.indexOf("mnp") === -1 ||
            window.location.href.indexOf("activation-inprogress") === -1 ||
            window.location.href.indexOf("activation-failed") === -1 ||
            window.location.href.indexOf("activated") === -1 ||
            window.location.href.indexOf("store-pickup") === -1 ||
            window.location.href.indexOf("delivery") === -1 ||
            window.location.href.indexOf("absher-validation") === -1 ||
            window.location.href.indexOf("confirmation") === -1) &&
            flag?.PaymentPending
          ) {
            localStorage.setItem("WelcomeBack", true);
            setDropOffJourney(false);
            setDropOffJourneyVisibility(false);
            setDropOffTime("");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
          }
          if (window.location.href.indexOf("random") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("category") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("search-number") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("number") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("mnp") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("activation-inprogress") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("activation-failed") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("activated") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("store-pickup") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("delivery") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("absher-validation") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (window.location.href.indexOf("confirmation") > 1) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
          if (!flag?.PaymentPending) {
            localStorage.removeItem("WelcomeBack");
            localStorage.removeItem("ReloadedOrLeft");
            localStorage.removeItem("TabSwitched");
            sessionStorage.removeItem("TabSwitchedBack");
            return;
          }
        }
      }
    });
  }, [window.location.href]); // eslint-disable-line react-hooks/exhaustive-deps


  const toggleDropOff = () => {
    setDropOffJourney((prev)=> !prev)
  }

  return <>{
    !error && 
    dropOffJourney &&
    localStorage.getItem("is_category_type_5g") === "false" &&
    window.location.href.substr(-3) !== "/#/" &&
    window.location.href.indexOf("random") === -1 &&
    window.location.href.indexOf("category") === -1 &&
    window.location.href.indexOf("search-number") === -1 &&
    window.location.href.indexOf("number") === -1 &&
    window.location.href.indexOf("mnp") === -1 &&
    window.location.href.indexOf("pay") === -1 &&
    window.location.href.indexOf("activation-inprogress") === -1 &&
    window.location.href.indexOf("activation-failed") === -1 &&
    window.location.href.indexOf("activated") === -1 &&
    window.location.href.indexOf("store-pickup") === -1 &&
    window.location.href.indexOf("delivery") === -1 &&
    window.location.href.indexOf("absher-validation") === -1 &&
    window.location.href.indexOf("confirmation") === -1 &&
    sessionStorage.getItem("TabSwitchedBack") === "true" ? 
     <DropOffScreen toggleDropOff={toggleDropOff}/> :
      <>{children}</>
      }</>;
};

export default DropOff;
